module.exports = __webpack_public_path__ + "static/media/Logo2.bd1cf92a.svg";